import { IPost, IRelatedPost } from '../lib/types';

export const parseFeaturedImage = (post: IPost | IRelatedPost) => {
  try {
    return post && post.featuredImage && post.featuredImage.node;
  } catch (e) {
    return null;
  }
};

export const parseCategory = (post: IPost) => {
  try {
    if (post.categories && post.categories.nodes && post.categories.nodes.length > 0) {
      return post.categories.nodes[0];
    }
  } catch (e) {}

  return null;
};
